import { useCallback } from 'react';

export type AnalyticsEvent =
  | 'profile_click'
  | 'profile_click_filtered'
  | 'profile_viewed'
  | 'profile_modal_opened'
  | 'profile_modal_closed'
  | 'profile_map_click'
  | 'photo_viewed';

export interface TrackPayload {
  profile_id?: string | number | null;
  metadata?: Record<string, unknown>;
}

export function useAnalytics() {
  const track = useCallback(
    (event: AnalyticsEvent, payload: TrackPayload = {}) => {
      const csrf = (
        document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement
      )?.content;

      // Fire-and-forget — never block UI interaction
      fetch('/api/analytics/event', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          event,
          profile_id: payload.profile_id ?? null,
          metadata: payload.metadata ?? null,
        }),
      }).catch(() => {
        // Swallow analytics errors — never surface to the user
      });
    },
    [],
  );

  return { track };
}
